.<div class="container-fluid">
    <div style="padding: 10px;">
    <div class="bg-white divunsuscribe" *ngIf="success">
        <div>Dear User, your mobile number is unsubscribed from the CompPBM.</div>
    </div>
</div>
</div>